import { useMemo } from 'react';

const CHOOSE_LATER_ONLY_GROUPS = ['49'];

export function useCreateNewCaseOptions(productMatrix) {
    const availableNewCaseOptions = useMemo(() => {
        let distrGroupId = null;
        try {
            distrGroupId = JSON.parse(localStorage.getItem('distr_group_id'));
        } catch (e) {
            distrGroupId = null;
        }
        if (distrGroupId === null || distrGroupId === 'null') {
            try {
                distrGroupId = JSON.parse(localStorage.getItem('doctor_dist_id'));
            } catch (e) {
                distrGroupId = null;
            }
        }

        const isChooseLaterOnlyGroup =
            distrGroupId !== null && distrGroupId !== 'null' && CHOOSE_LATER_ONLY_GROUPS.includes(String(distrGroupId));

        return (
            productMatrix?.filter((v) => {
                const isSmileDesign = v.case_type?.includes('SMILE_DESIGN');
                const isRetainer = v.case_type === 'RETAINER';

                if (isSmileDesign || isRetainer) return false;
                if (isChooseLaterOnlyGroup && v.case_type !== 'CHOOSE_LATER') return false;

                return true;
            }) ?? []
        );
    }, [productMatrix]);

    return { availableNewCaseOptions };
}
